import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { Dashboard, DefaultDashboard } from "../../../../Constants/Constants";
import WelcomeBackCard from "./WelcomeBackCard";
import HigherRevenue from "./HigherRevenue";
import RecentActivity from "./RecentActivity";
import TasksList from "./TasksList";
import NotificationsCard from "./NotificationsCard";
import TotalSales from "./TotalSales";
import LearningSummary from "./LearningSummary";
import CurrentOrders from "./CurrentOrders/CurrentOrders";
import TrendingNews from "./TrendingNews";
import SalesByProduct from "./SalesByProduct/SalesByProduct";
import CustomerReview from "./CustomerReview";
import { Fragment } from "react/jsx-runtime";

const DefaultContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={DefaultDashboard} parent={Dashboard} />
      <Container fluid className="default-dashboard">
        <Row>
          <WelcomeBackCard />
          <HigherRevenue />
          <RecentActivity />
          <TasksList />
          <NotificationsCard />
          <TotalSales />
          <LearningSummary />
          <CurrentOrders />
          <TrendingNews />
          <CustomerReview />
          <SalesByProduct />
        </Row>
      </Container>
    </Fragment>
  );
};

export default DefaultContainer;
